export default "__VITE_ASSET__416dae4a__"